// Base URL of your backend
//export const BASE_URL = "http://localhost:8081/api";
export const BASE_URL = "https://speakboldwithkk.com/api";

// Endpoints
export const API_SUBSCRIBE = `${BASE_URL}/subscribe`;
export const API_LOGIN = `${BASE_URL}/login`;
export const API_REGISTER = `${BASE_URL}/register`;
export const API_EMAIL_SUBSCRIBER = `${BASE_URL}/email_subscribe`;